// @module Tavanoteam.QuantityIncrement.QuantityIncrement
define('Tavanoteam.QuantityIncrement.QuantityIncrement.Model'
    , [
        'Product.Model'

        , 'Backbone'
        , 'Utils'
        , 'underscore'
    ]
    , function (
        ProductModel

        , Backbone
        , Utils
        , underscore
    ) {
        'use strict';

        return _.extend(ProductModel.prototype, {

            //Modify validation. Check if the quantity entered is in multiples of the declared value in custitem_qty_increment
            validation: _.extend(ProductModel.prototype.validation, {
                quantity: {
                    fn: function quantityValidator(new_quantity) {


                        var current_quantity = parseInt(new_quantity, 10);
                        var maximum_quantity = this.getItem().get('_maximumQuantity');
                        var minimum_quantity = this.getItem().get('_minimumQuantity');
                        var item_quantity_in_cart = this._getItemQuantityInCart();
                        var increment_value = this.getItem().get('custitem_qty_increment');

                        var isInvalid = (current_quantity % increment_value) != 0 ? true : false;

                        if (!increment_value) {
                            isInvalid = false;
                        }

                        if (
                            !_.isNumber(current_quantity) ||
                            _.isNaN(current_quantity) ||
                            current_quantity < 1 ||
                            isInvalid
                        ) {
                            return Utils.translate('Invalid quantity value');
                        }
                        if (item_quantity_in_cart + current_quantity < minimum_quantity) {
                            return Utils.translate(
                                'Please add $(0) or more of this item',
                                minimum_quantity
                            );
                        }
                        if (
                            maximum_quantity &&
                            item_quantity_in_cart + current_quantity > maximum_quantity
                        ) {
                            return Utils.translate(
                                'Please add $(0) or less of this item',
                                maximum_quantity - item_quantity_in_cart
                            );
                        }
                    }
                },
                options: {
                    fn: function optionsValidator() {
                        var are_options_with_error = false;

                        this.get('options').each(function (option) {
                            are_options_with_error = are_options_with_error || !!option.validate();
                        });
                        return are_options_with_error && Utils.translate('Invalid options values');
                    }
                }
            })
        })
    });
